export const HOSPITAL_INFO_SECTIONS = [
  ['parking', 'Parking', 'Car'],
  ['visiting_times', 'Visiting times', 'Clock3'],
  ['ward_maps', 'Ward maps', 'Map'],
  ['cafes', 'Cafés', 'Coffee'],
  ['prayer_rooms', 'Prayer rooms', 'HeartHandshake'],
  ['facilities', 'Facilities', 'Building2'],
  ['wifi', 'Wi-Fi', 'Wifi'],
  ['accessibility', 'Accessibility', 'Accessibility'],
  ['transport', 'Transport', 'Bus'],
  ['pharmacy', 'Pharmacy', 'Pill'],
  ['cash_machine', 'Cash machine', 'Banknote'],
  ['baby_changing', 'Baby changing', 'Baby'],
  ['quiet_spaces', 'Quiet spaces', 'VolumeX'],
].map(([id, title, icon]) => ({ id, title, icon }));

export const HOSPITAL_INFO_STATES = ['available', 'unavailable', 'hidden'];

export function normaliseHospitalInfo(value = {}) {
  return Object.fromEntries(HOSPITAL_INFO_SECTIONS.map((section) => {
    const item = value?.[section.id] || {};
    const state = HOSPITAL_INFO_STATES.includes(item.state) ? item.state : 'unavailable';
    return [section.id, {
      state,
      url: state === 'available' ? String(item.url || '').trim() : '',
    }];
  }));
}
